import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { theme } from '../../../db.json';
import { ContainerMenuButtons } from '../../../components/Containers';
import ButtonMainContainer from '../../../components/Home/MainContainer/ButtonMainContainer';
import { SearchLinksSystemsAction } from '../../../redux/actions/linksSystem';

export default function UserSpa() {
  const themeColors = theme.colors.systems;
  const prefix = '/images/icons/buttons/';
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SearchLinksSystemsAction());
  }, [dispatch]);

  return (
    <ContainerMenuButtons>
      <ButtonMainContainer
        type="button"
        color={themeColors.CadastrarPessoas}
        name="Cadastrar Pessoas"
        link="/registro-pessoa"
        linkImg={`${prefix}user.svg`}
      />
      <ButtonMainContainer
        type="button"
        color={themeColors.ListarPessoas}
        name="Listar Pessoas"
        link="/pessoas-cadastradas"
        linkImg={`${prefix}users.svg`}
      />
    </ContainerMenuButtons>
  );
}
